(function() {
    'use strict';

    var VisibilitaRapportiCtrl = function(
        $q,
        $scope,
        $state,
        $stateParams,
        $cacheFactory,
        CONSTANTS,
        messaggiFctr,
        visibilitaRapportiService,
        gestioneUtenteService
    ) {

        this.loading = 0;
        this.gestioneUtenteService = gestioneUtenteService;

        this.cambiaVisibilitaRapporto = (rapporto) => {
            rapporto.visibile = !rapporto.visibile
        };

        this.getStatoRecuperoRapporti = function () { 
            return gestioneUtenteService.rapportiCaricati; 
        };

        this.nessunRapportoRecuperato = function () { 
            let flagLoading = [0, 'OK'].includes(this.getStatoRecuperoRapporti()); 
            let flagRapportiVuoti = !this.gestioneUtenteService.datiMito.rapporti || this.gestioneUtenteService.datiMito.rapporti.length === 0; 
            return flagLoading && flagRapportiVuoti;
        };
    };

    VisibilitaRapportiCtrl.$inject = [
        '$q',
        '$scope',
        '$state',
        '$stateParams',
        '$cacheFactory',
        'Mitom_CONSTANTS',
        'MitomMessaggiFctr',
        'MitomVisibilitaRapportiService',
        'MitomGestioneUtenteService'
    ];

    var TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'mitoman-gestione-utente/mitoman-visibilita-rapporti/visibilitaRapporti.component.html'
        );
    };
    TemplateUrl.$inject = ['Mitom_CONSTANTS'];

    var VisibilitaRapportiComponent = {
        controller: VisibilitaRapportiCtrl,
        controllerAs: 'visibilitaRapportiCtrl',
        templateUrl: TemplateUrl
    };

    angular
        .module('cbl.mitomanager.wa')
        .component('mitomvisibilitaRapporti', VisibilitaRapportiComponent);
})();